var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLab1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_127_683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75054 15.375C3.27216 15.375 2.93216 15.1616 2.73054 14.7347C2.52879 14.3077 2.57748 13.9106 2.8766 13.5433L7.12554 8.37975V3.75H6.23135C6.07198 3.75 5.93835 3.69606 5.83048 3.58819C5.72273 3.48031 5.66885 3.34669 5.66885 3.18731C5.66885 3.02781 5.72273 2.89425 5.83048 2.78662C5.93835 2.67887 6.07198 2.625 6.23135 2.625H11.7697C11.9291 2.625 12.0627 2.67894 12.1706 2.78681C12.2784 2.89469 12.3322 3.02831 12.3322 3.18769C12.3322 3.34719 12.2784 3.48075 12.1706 3.58838C12.0627 3.69613 11.9291 3.75 11.7697 3.75H10.8755V8.37975L15.1245 13.5433C15.4236 13.9106 15.4723 14.3077 15.2705 14.7347C15.0689 15.1616 14.7289 15.375 14.2505 15.375H3.75054ZM3.75054 14.25H14.2505L9.75054 8.775V3.75H8.25054V8.775L3.75054 14.25Z",
    fill: "#189FAA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_127_683"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLab1);
export default __webpack_public_path__ + "static/media/lab1.f157a2c1c0f171b56b36f69f6de5e5f1.svg";
export { ForwardRef as ReactComponent };